import React from "react";

const LoadingCloudStorage = () => {
    return (
        <div className="loading_container">
            <div className="bottom_loading">
                {Array.from({ length: 5 }).map((_, index) => (
                    <div key={index} className="bottom_loading_item"></div>
                ))}
            </div>
            <div className="header_loading_cloud"></div>
        </div>
    );
};

export default LoadingCloudStorage;
